(function () {
  // The 27 EU member states. Add EEA countries (NO, IS, LI) too if you want -
  // the customs/IOSS friction this is aimed at is an EU-specific thing though.
  var EU_COUNTRIES = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
    'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK',
    'SI', 'ES', 'SE'
  ];

  var REDIRECT_URL = 'https://www.armstrongmusic.co.uk';

  var CONSENT_COOKIE = 'armstrong_eu_redirect_consent'; // set only on "yes"
  var CONSENT_DAYS = 365; // how long a "yes" is remembered before asking again
  var DISMISS_COOKIE = 'armstrong_eu_popup_dismissed'; // set only on "no" / close
  var DISMISS_DAYS = 14; // how long a "no" is respected before asking again

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
  }

  // Already said yes previously - honour that consent and go straight there,
  // no popup needed. This is the part that makes it feel "automatic" after
  // the first visit while still being based on an explicit earlier consent.
  if (getCookie(CONSENT_COOKIE)) {
    window.location.href = REDIRECT_URL;
    return;
  }

  // Said no recently - leave them alone for a while.
  if (getCookie(DISMISS_COOKIE)) return;

  var overlay = document.getElementById('armstrong-eu-popup-overlay');
  var yesBtn = document.getElementById('armstrong-eu-popup-yes');
  var noBtn = document.getElementById('armstrong-eu-popup-no');
  var closeBtn = document.getElementById('armstrong-eu-popup-close');
  if (!overlay) return;

  function dismiss() {
    overlay.hidden = true;
    setCookie(DISMISS_COOKIE, '1', DISMISS_DAYS);
  }

  function accept() {
    setCookie(CONSENT_COOKIE, '1', CONSENT_DAYS);
    window.location.href = REDIRECT_URL;
  }

  // Free IP geolocation lookup, no API key needed. If ipwho.is is ever down,
  // ipapi.co/json/ is a solid drop-in - swap the URL and use data.country_code.
  // cache: 'no-store' + a timestamp on the URL stop the browser (or iOS Safari
  // in particular) from ever reusing a stale answer from an earlier visit.
  fetch('https://ipwho.is/?_=' + Date.now(), { cache: 'no-store' })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data && data.success !== false && EU_COUNTRIES.indexOf(data.country_code) !== -1) {
        overlay.hidden = false;
      }
    })
    .catch(function () {
      // Fail silently - if the lookup fails, just don't show the popup.
      // Never let this block or slow down the rest of the page.
    });

  if (yesBtn) yesBtn.addEventListener('click', accept);
  if (noBtn) noBtn.addEventListener('click', dismiss);
  if (closeBtn) closeBtn.addEventListener('click', dismiss);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) dismiss();
  });

  // iOS Safari (and some other browsers) can restore a page exactly as you
  // left it when you tap "back", without actually re-running this script -
  // so a popup shown on an earlier visit can reappear even though your
  // location (or VPN) has since changed. Force a real reload when that
  // happens, so the check above always runs fresh.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  });
})();
